// extracted by mini-css-extract-plugin
module.exports = {"root":"Notification_root__bjxWL","openAnimation":"Notification_openAnimation__sMCQB"};